import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { PageTitleAndSubTitle } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { RECOMMENDED_APPS } from '../../core-utils/messages/RecommendedAppConstants';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import properties from '../../core-utils/properties';
import axios from 'axios';
import ComparisonTable from '../../_components/atoms/ComparisonTable';
import Loader from '../../_components/molecules/Loader';
import { useNavigate } from 'react-router-dom';
import {
  MA_DUE_DILIGENCE_ADD,
  MA_DUE_DILIGENCE_INTERNAL,
} from '../../core-utils/routes';
import {
  DueDiligenceDataType,
  formatComparisonTableData,
} from '../../core-utils/helper-utils/recommendedAppsHelper';
import { compilationDataProps } from '../TermCompilerPage';

const MADueDiligencePage: React.FC<{}> = observer(({}) => {
  const { classes } = makeStyles()({
    root: {
      display: 'flex',
      flexDirection: 'column',
    },
    titleAndSubtitle: {
      width: '1276px',
      padding: '40px 0px 0px 63px',
    },
    main: {
      width: '1276px',
      padding: '0px 0px 0px 63px',
    },
    hr: {
      width: '100%',
      border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
      margin: '18px 0px',
    },
  })();

  const messages = RECOMMENDED_APPS.MA_DUE_DILIGENCE;
  const navigate = useNavigate();
  const [dueDiligenceData, setDueDiligenceData] = useState<
    DueDiligenceDataType[]
  >([]);
  const [loading, setLoading] = useState<boolean>(false);

  const handleRowClick = (
    eg_nid: DueDiligenceDataType['eg_nid'],
    status: DueDiligenceDataType['status'] | compilationDataProps['status'],
  ) => {
    if (status === 'Ready') {
      navigate(MA_DUE_DILIGENCE_INTERNAL, { state: { eg_nid } });
    }
  };

  const handleAddProject = () => {
    navigate(MA_DUE_DILIGENCE_ADD);
  };

  const getDueDiligenceDetails = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.getDueDiligenceDetails,
      );
      setDueDiligenceData(response.data?.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDueDiligenceDetails();
  }, []);

  if (loading) {
    return <Loader />;
  }
  return (
    <Grid container className={classes.root}>
      <Grid className={classes.titleAndSubtitle}>
        <PageTitleAndSubTitle
          title={messages.TITLE}
          subTitle={messages.SUBTITLE}
          showQueryDataButton
          queryButtonText="New Project"
          queryDataAction={handleAddProject}
        />
      </Grid>
      <hr className={classes.hr} />
      <Grid className={classes.main}>
        <ComparisonTable
          columns={[
            { name: 'Group Name' },
            { name: 'Date Created' },
            { name: 'Type of Plan' },
            { name: 'Documents' },
            { name: 'Parameters' },
          ]}
          rowsData={formatComparisonTableData(dueDiligenceData)}
          handleRowClick={handleRowClick}
        />
      </Grid>
    </Grid>
  );
});

export default MADueDiligencePage;
